import Card from "@material-ui/core/Card";
import { makeStyles, Theme } from "@material-ui/core/styles";
import ForwardIcon from "@material-ui/icons/Forward";
import { useMemo } from "react";
import { useAppState } from "../../../../../../../../common/appState";
import { XpBooster } from "../../../components/OpenableCards/ItemsCard/items/ItemClass/XpBooster/XpBooster";
import { FormattedRemainingTime } from "./FormattedRemainingTime";

export function XpBoostTimer({ screenWidth }: { screenWidth: number }) {
    const c = useStyles({ isWide: screenWidth >= 500 });

    const [xpBoostRemainingSeconds] = useAppState("xpBoostRemainingSeconds");
    const [lastUsedXpBooster] = useAppState("lastUsedXpBooster");
    const boosterMessage = useMemo(
        () =>
            lastUsedXpBooster && new XpBooster(lastUsedXpBooster).boostMessage,
        [lastUsedXpBooster]
    );

    if (xpBoostRemainingSeconds <= 0 || !lastUsedXpBooster) {
        return null;
    }

    return (
        <Card className={c.container}>
            <ForwardIcon className={c.icon} />
            <div className={c.centerArea}>
                <div className={c.message}>{boosterMessage}</div>
                <div>
                    <FormattedRemainingTime
                        remainingSeconds={xpBoostRemainingSeconds}
                    />
                </div>
            </div>
            <ForwardIcon className={c.icon} />
        </Card>
    );
}
const useStyles = makeStyles<Theme, { isWide: boolean }>(theme => ({
    container: {
        width: "100%",
        height: 80,
        borderRadius: 40,
        backgroundColor: theme.palette.secondary.main,
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        margin: "10px 0 15px",
        animation: "10s linear infinite ninjaCommentAnime",
    },
    centerArea: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        margin: -15,
    },
    message: ({ isWide }) => ({
        fontSize: isWide ? "x-large" : "23px",
        fontWeight: "bold",
        whiteSpace: "nowrap",
    }),
    icon: ({ isWide }) => ({
        color: theme.palette.secondary.main,
        backgroundColor: "white",
        transform: "rotate(-90deg)",
        width: isWide ? 70 : 40,
        height: isWide ? 70 : 40,
        borderRadius: "50%",
        margin: isWide ? 5 : 15,
    }),
}));
